import * as React from 'react';

// ICONS
import { ReactComponent as DownloadIcon } from '../assets/svg/download.svg';

// TYPES
interface DownloadLinkTypes {
	className?: string;
	url?: string;
	name?: string;
}

export const DownloadLink: React.FC<DownloadLinkTypes> = ({ className = '', url, name }) => {
	return (
		<a href={url || ''} download={name} className={`download-link ${className}`}>
			<span className="link-name">{name}</span>

			<span className="link-text d-none d-lg-block">Download</span>
			
			<DownloadIcon className="link-icon d-block d-lg-none" />
		</a>
	);
};

export default DownloadLink;
